<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="搜索">
          <el-input placeholder="请输入商品名称/规格/分类" v-model="formInline.search">
        
          </el-input>
        </el-form-item>


        <Supply :form="form"></Supply>
<!-- 
        <el-form-item label="批次">
          <el-input placeholder="请输入批次" v-model="formInline.batchNumber">
        
          </el-input>
        </el-form-item>  -->
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

          <el-button  size="small" v-if="showBack" type="info" @click="gotoBack">返回上一页</el-button>
        </el-form-item>


        <div style="font-size: 14px;font-weight: bold;">当前库存总量：{{ stockAll }}</div>
        <div style="font-size: 14px;font-weight: bold;">当前虚拟库存总量： {{ xnstockAll }}</div>
       
        <div>会联动上面的入库到哪条件</div>

      </el-form>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- <el-table-column prop="batchNumber" label="批次号"></el-table-column> -->
            <el-table-column prop="supply.name" label="从哪入库"></el-table-column>
            <el-table-column prop="tsupply.name" label="入库到哪"></el-table-column>

            <el-table-column prop="warehouse_kw_text" label="库区"></el-table-column>
            
            <el-table-column prop="productImage" label="商品图片">
              <template slot-scope="scope">
              <div v-if="scope.row.productImage">
                <img :src="scope.row.productImage" width="30px" height="30px"/>
              </div>
            </template>

            </el-table-column>
            <el-table-column prop="productCategory" label="商品分类"></el-table-column>
            <el-table-column prop="productName" label="商品名称"></el-table-column>
            <el-table-column prop="productSpecification" label="商品规格" width="60"></el-table-column>
            <el-table-column prop="salesUnit" label="销售单位" width="60"></el-table-column>
            <el-table-column prop="purchasePrice" label="进货价" width="60"></el-table-column>
            <el-table-column prop="product_price" label="销售价(元)">
              <template slot-scope="scope">
              <div> 
                <el-input v-model="scope.row.product_price"  
                @blur="handleBlur(scope.row,'product_price')"
                placeholder="请输入" style="width: 100px;"></el-input>
              </div>
            </template>

            </el-table-column>
            <el-table-column prop="line_price" label="划线价">
              <template slot-scope="scope">
              <div> 
                <el-input v-model="scope.row.line_price"  
                @blur="handleBlur(scope.row,'line_price')"
                placeholder="请输入" style="width: 100px;"></el-input>
              </div>
            </template>

            </el-table-column>
            <el-table-column prop="actualInventory" label="实际库存">
      
              <template slot-scope="scope">
              <div> 
                <!-- <el-input v-model="scope.row.actualInventory"  
                @blur="handleBlur(scope.row,'actualInventory')"
                placeholder="请输入" style="width: 100px;"></el-input> -->
                {{ scope.row.actualInventory }}
              </div>
            </template>

            </el-table-column>


            <el-table-column prop="actualInventory" label="进货总金额" width="60">
      
              <template slot-scope="scope">
              <div> 

                {{ (scope.row.actualInventory *  scope.row.purchasePrice).toFixed(2)}}
              </div>
            </template>

            </el-table-column>


            <el-table-column prop="virtualInventory"  label="虚拟库存">
              <template slot-scope="scope">
              <div> 
                <el-input v-model="scope.row.virtualInventory"  
                @blur="handleBlur(scope.row,'virtualInventory')"
                placeholder="请输入" style="width: 100px;"></el-input>
              </div>
            </template>



            </el-table-column>
            <el-table-column prop="actualInventoryAlert"  label="实际库存预警数">
              <template slot-scope="scope">
              <div> 
                <el-input v-model="scope.row.actualInventoryAlert"  
                @blur="handleBlur(scope.row,'actualInventoryAlert')"
                placeholder="请输入" style="width: 100px;"></el-input>
              </div>
            </template>

            </el-table-column>
            <el-table-column prop="virtualInventoryAlert" label="虚拟库存预警数">

              <template slot-scope="scope">
              <div> 
                <el-input v-model="scope.row.virtualInventoryAlert"  
                @blur="handleBlur(scope.row,'virtualInventoryAlert')"
                placeholder="请输入" style="width: 100px;"></el-input>
              </div>
            </template>
            </el-table-column>

      


          
            <!-- <el-table-column prop="totalAmount" label="总金额"></el-table-column>-->
            <!-- <el-table-column prop="grossProfitMargin" label="毛利率">
                

            </el-table-column>  -->

            <el-table-column prop="product_price" label="上下架状态">
              <template slot-scope="scope">
                <div v-if="scope.row.is_on == 0"> 下架中</div>
                <div v-if="scope.row.is_on == 1"> 上架中</div>
            </template>
          </el-table-column>

            <el-table-column prop="virtualInventoryAlert"  label="上下架操作">

                <template slot-scope="scope">
                <div> 
                  <el-switch v-model="scope.row.is_on" active-color="#13ce66" 
                inactive-color="#ff4949"  @change="handleBlur(scope.row,'is_on')"
                :active-value="1" :inactive-value="0"></el-switch>
                </div>
                </template>
            </el-table-column> 

       
            <el-table-column fixed="right" label="操作"  width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :warehouse_inventorys_id="warehouse_inventorys_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Existing_inventoryApi from '@/api/existing_inventory.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Supply from '@/components/supply/supply_commons.vue';
  export default {
    components: {
      Add,
      Edit,
      Supply,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {
          supply:{},
          tsupply:{},
        },
        formInline: {
          search:"",
          batchNumber:""
        },
        stockAll:0,

        open_add:false,
        open_edit:false,
        warehouse_inventorys_id:"",
        dialogVisible:false,
        showBack:false,
        isuse:1,
        xnstockAll:0,
        stockAll:0,
      };
    },
    created() {
      var self = this;
      self.getInas({},function(res){
        console.log(res)
        self.isuse = res
      })
      if(this.$route.query.is_show && this.$route.query.is_show == 1){
        this.showBack = true;
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
             /*返回上一页面*/
             gotoBack(){
        this.$router.back(-1);
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//现有库存标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.supply_id = self.form.supply_id
        Params.t_supply_id = self.form.t_supply_id
        self.loading = true;
        Existing_inventoryApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.stockAll =  data.data.stockAll;
            self.xnstockAll =  data.data.xnstockAll;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.warehouse_inventorys_id = row.warehouse_inventorys_id;
        this.open_edit = true
      },
      handleBlur(row,key){
        var self = this;
        Existing_inventoryApi.editPart(
              {
                warehouse_inventorys_id: row.warehouse_inventorys_id,
                cond:[
                {
                  'key':key,
                  'val':row[key]
                }
                ]
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '修改成功',
                    type: 'success'
                  });
  
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });

      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Existing_inventoryApi.del(
              {
                warehouse_inventorys_id: row.warehouse_inventorys_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/existing_inventory/index/index.vue